/** DECON pallet group flow — single supported DC site. */
export const DC_SITE_CODE = "ELCLKDL";
export const DC_SITE_LABEL = DC_SITE_CODE;
